import React from "react";
import NewCustomerForm from "../../components/NewCustomerForm/NewCustomerForm"

const Resources = () => {
    return (
        <div className="new-client-container">
            <div>
                <NewCustomerForm />
            </div>

        </div>
    );
};

export default Resources;